/*******************************************************************************
TRIGGER A SUB NAVIGATION LIST
Handles a click on a link with sub-navigation.
*******************************************************************************/

export default function triggerCloseSubNav(e) {
    const $moreFiltersButton = $(e.currentTarget);
    const $filterSet = $moreFiltersButton.siblings('.filter-links');
    const $filterWrapper = $filterSet.parents('.filter-links-wrapper');
    const $title = $filterWrapper.siblings('.filter-links-title');
    const level = $('.is-sub-link:not(.hide):first').data('level');
    const inDeepNav = level > 2;

    // If we're two levels deep, just go up one level
    if (inDeepNav) {
        const navName = $filterSet.find('.filter-link:not(.hide):first').data('parent');
        const parentName = $filterSet.find(`.is-sub-link[data-name="${navName}"]:first`).data('parent');

        // Hide all the sub nav items
        $filterSet.find('.is-sub-link').addClass('hide');

        // Show the sub-items for the active filter
        $(`.is-sub-link[data-parent="${parentName}"]`).removeClass('hide');

        // Update the secondary title
        $title.find('.filter-links-sub-title').text(parentName);

    }
    else {
        // Remove the sub nav class to the wrapper (used for adjusting styles)
        $filterWrapper.addClass('is-showing-sub-nav');

        // Remove the "more filters" button
        $moreFiltersButton.remove();

        // Show all the top level filters
        $filterSet.find('.filter-link').removeClass('hide');

        // Hide all the sub nav items
        $filterSet.find('.is-sub-link').addClass('hide');

        // Remove the secondary title
        $title.find('.filter-links-sub-title').remove();
    }
}
